module.exports = "https://p.cds.unp.clasificados.pe/book-claimer.6290b0541263ddbf153b13c4999ef188.jpg";